import { SET_CHAT, SET_LOADING, SET_LOGO } from "../ConstAction";
const initialState = {};
export const ChatData = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGO:
      return {
        details: action.response.data,
        loading: false,
      };
    case SET_CHAT:
      return {
        ...state,
        list: action.response.data,
        loading: false,
        empty: false,
      };
    case SET_LOADING:
      return {
        loading: action.data,
      };
    default:
      return null;
  }
};
